/**
 * Top bar (main menu) dropdown menus
 */

import $ from 'jquery';
import { hoverIntent } from 'utilities/hover-intent.js';
import { getPageId, getActiveMenuItem } from 'components/navigation/active-menu-item.js';

const topBar = document.querySelector('.top-bar');
const topBarBackground = getComputedStyle(document.documentElement).getPropertyValue('--topbar-background').trim();
const pageId = getPageId();

// Dropdown triggers
// -----------------

// Main menu links with dropdown menus
const dropdownTriggers = document.querySelectorAll(".menu-bar a.has-dropdown");

// Custom hover function to open (and keep open) Foundation Dropdown panes
dropdownTriggers.forEach(dropdownTrigger => {
  const target = '#' + dropdownTrigger.dataset.toggle;
  // const dropdownMenu = new Foundation.Dropdown($(target));

  hoverIntent(
    dropdownTrigger,
    () => {
      // Open Dropdown pane
      $(target).foundation('open');
      // console.log(dropdownMenu); 
      // dropdownMenu.open()  
    },
    () => { },
    200 // delay in ms
  );
});

// Dropdown pane open events
document.querySelectorAll('.dropdown-pane.main-menu, .dropdown-pane.search-bar').forEach(pane => {
  $(pane).on('show.zf.dropdown', function() {
    const paneEl = this;

    // Fix Foundation Drilldown component when Dropdown panes open.
    // Drilldown measures height at init while inside a hidden pane (getBoundingClientRect returns 0).
    // Force a resize now that the pane is visible so dimensions are recalculated correctly.
    const drilldowns = paneEl.querySelectorAll('ul[data-drilldown]');
    drilldowns.forEach(drilldown => {
      // Defer until after the browser has laid out the now-visible dropdown
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          $(drilldown).trigger('mutateme.zf.trigger');
        });
      });
    });

    // Show page overlay
    $('.menu-page-overlay').fadeIn(300);

    // Enable top bar background colour
    if (document.body.classList.contains('has-top-bar-overlay') &&topBar.classList.contains('top-bar-overlay')) {
      topBar.style.backgroundColor = topBarBackground;
    }

    // Navigate to active menu item if applicable (after resize so submenu dimensions are correct)
    const runActiveMenuItem = () => {
      if (pageId) {
        const activeMenuItem = getActiveMenuItem(paneEl, '[data-drilldown]');
        if (activeMenuItem) {
          const [activeDrilldown, activeMenu, activeLink] = activeMenuItem;
          if (activeLink && activeMenu && activeDrilldown) {
            activeLink.classList.add('is-active');
            $(activeDrilldown).foundation('_showMenu', $(activeMenu), false);
            const activeLinkLi = activeLink.closest('li');
            if (activeLinkLi) {
              const childSubmenu = activeLinkLi.querySelector('ul.menu');
              if (childSubmenu) {
                $(activeDrilldown).foundation('_showMenu', $(childSubmenu), false);
              }
            }
          }
        }
      }
    };
    // Run after drilldown resize so submenu has correct dimensions
    if (drilldowns.length) {
      requestAnimationFrame(() => {
        requestAnimationFrame(runActiveMenuItem);
      });
    } else {
      runActiveMenuItem();
    }
  })
  .on('hide.zf.dropdown', function() {
    // Hide page overlay
    document.querySelector('.menu-page-overlay').style.display = 'none';

    // Remove top bar background colour
    if (document.body.classList.contains('has-top-bar-overlay') &&topBar.classList.contains('top-bar-overlay')) {
      topBar.style.backgroundColor = 'transparent';
      // topBar.classList.remove('has-background');
    }
  });
});



